import { PlanDefinition } from "@medplum/fhirtypes";

import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "..";

const labOrderTemplatesAdapter = createEntityAdapter({
  selectId: (labOrderTemplate: PlanDefinition) => labOrderTemplate.id!,
});

const reducers = {
  loadLabOrderTemplates: labOrderTemplatesAdapter.setAll,
  removeLabOrderTemplate: labOrderTemplatesAdapter.removeOne,
  upsertLabOrderTemplate: labOrderTemplatesAdapter.upsertOne,
};

export const labOrderTemplatesSlice = createSlice({
  name: "labOrderTemplates",
  initialState: labOrderTemplatesAdapter.getInitialState(),
  reducers,
});

export const { loadLabOrderTemplates, removeLabOrderTemplate, upsertLabOrderTemplate } =
  labOrderTemplatesSlice.actions;

const selectLabOrderTemplatesEntities = (state: RootState) => state.labOrderTemplates.entities;

export const selectLabOrderTemplatesList = createSelector(
  [selectLabOrderTemplatesEntities],
  (labOrderTemplatesEntities): PlanDefinition[] =>
    Object.values(labOrderTemplatesEntities).sort((a, b) => {
      const aDate = a.meta?.lastUpdated ? new Date(a.meta.lastUpdated).getTime() : 0;
      const bDate = b.meta?.lastUpdated ? new Date(b.meta.lastUpdated).getTime() : 0;
      return bDate - aDate;
    }),
);

export default labOrderTemplatesSlice.reducer;
